export default __webpack_public_path__ + "static/media/ChangeLanguageIcon.20b13709.svg";